module.exports = __webpack_public_path__ + "032bff1a78a9aaa5abd782cf5d9f487b.jpg";